$(document).ready(function () {
  let menuOpen = false;

  const slowToFast = "all 1s cubic-bezier(0.25, 0.1, 0.25, 1)";
  const fastToSlow = "all 1s cubic-bezier(0.25, 0.1, 0.25, 1)";
  const linear = "all 0.8s ease";
  const delay = "0.3s";

  const animationData = {
    top: {
      open: { top: -100, transition: slowToFast, transitionDelay: "0.2s" },
      close: { top: 0, transition: fastToSlow, transitionDelay: "0.4s" },
    },
    topImage1: {
      open: { transform: "rotateY(720deg)", transition: "all 1s linear" },
      close: {
        transform: "rotateY(-180deg)",
        transition: "all 1.5s linear",
        transitionDelay: "0.6s",
      },
    },
    middle: {
      open: { top: 0, transitionDelay: "0.4s" },
      close: { top: 38, transitionDelay: "0.4s" },
    },
    bottom: {
      open: { top: 42, transition: slowToFast, transitionDelay: "0.8s" },
      close: { top: 100, transition: fastToSlow, transitionDelay: "0.2s" },
    },
    bottomImage1: {
      open: {
        transform: "rotateY(360deg)",
        transition: "all 1.5s linear",
        transitionDelay: "0.6s",
      },
      close: { transform: "rotateY(-180deg)", transition: slowToFast },
    },
  };

  // Toggle menu on button or .menu_text click
  $("#menu-button, .menu_text").click(function () {
    console.log("Menu toggled");
    if (!menuOpen) {
      animateBottle("open");
    } else {
      animateBottle("close");
    }
    menuOpen = !menuOpen;
  });

  // Function to handle animations
  function animateBottle(state) {
    $("#top").css(animationData.top[state]);
    $("#top_image_1").css(animationData.topImage1[state]);
    $("#middle").css(animationData.middle[state]);
    $("#bottom").css(animationData.bottom[state]);
    $("#bottom_image_1").css(animationData.bottomImage1[state]);
  }

  // Close the menu if clicking outside
  $(document).click(function (event) {
    if (menuOpen && !$(event.target).closest(".menubar, #menu-button, .menu_text").length) {
      console.log("Clicked outside, closing menu");
      animateBottle("close");
      menuOpen = false;
    }
  });
});
